import React, { useEffect, useState, useRef } from "react";
import { Loginwrapper } from "../style";
import Input from "../../ui/Input";
import Button from "../../ui/Button";
import OtpInput from "../../OtpInput/OtpInput";
import imgLogin from '../../../images/loginImg.png';
import { getStorage, isEmpty, isNumber, setStorage } from "../../../Utils/common";
import { Link, useNavigate } from "react-router-dom";
import { sendotpForLogin, verifyotpForLogin, ckeckEligibility } from "../../../Utils/api";
import Alert from "../../ui/Alert";
import MobileInput from "../../OtpInput/MobileInput";
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GiPayMoney, GiTakeMyMoney } from "react-icons/gi";
import { VscCombine } from "react-icons/vsc";
import { BsFillGrid1X2Fill } from "react-icons/bs";
import { AiOutlineFileDone } from "react-icons/ai";
import { VscOpenPreview } from "react-icons/vsc";
import { IoMdDoneAll } from "react-icons/io";
import process_line from "../../../images/process_line.svg";
import { Helmet } from "react-helmet";
import logo from '../../../images/credu_loan_logo.png'
import { CiEdit } from "react-icons/ci";

function Login() {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [screen, setScreen] = useState("getOtp");
  const [seconds, setSeconds] = useState(0);
  const [mobile, setMobile] = useState(["", "", "", "", "", "", "", "", "", ""]);
  const [mobileError, setMobileError] = useState("");
  const [loading, setLoading] = useState(false);
  const [accept, setAccept] = useState(false);
  const [acceptError, setAcceptError] = useState("");
  const [message, setMessage] = useState({});
  const [responce, setResponce] = useState({});
  const inputRefs = useRef([]);
  const navigate = useNavigate();
  const [showMore, setShowMore] = useState(false);

  // Extract UTM parameters from the URL
  const getUtmParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_term: params.get("utm_term") || "",
      utm_content: params.get("utm_content") || ""
    };
  };


  useEffect(() => {
    const utmParams = getUtmParams();
    if (utmParams.utm_term) {
      // sessionStorage.setItem("utm_term", utmParams.utm_term);
      setStorage("clickId", utmParams.utm_term);

    }
  }, []);




  useEffect(() => {
    if (screen === "getOtp") return;
    const timer = setInterval(() => {
      if (seconds === 0) {
        clearInterval(timer);
      } else {
        setSeconds(seconds - 1);
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [seconds]);

  const onChanges = (e, type) => {
    const { name, value } = e.target;

    if (type === "sendOtp") {
      if (!isNumber(value) && !isEmpty(value)) return;
      setMobile(value);
      setMobileError("");
    }
  };

  const sendOtp = () => {
    let mobileNumber = mobile.join("");

    if (mobileNumber.length !== 10) {
      setMessage({ type: 'error', msg: "The Mobile field must be at least 10 characters in length." });
      return;
    }
    if (!accept) {
      setAcceptError("Please check the checkbox to accept our terms and conditions");
      return;
    } else {
      setAcceptError("");
    }

    // Get UTM parameters from the URL
    const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } = getUtmParams();

    const param = {
      mobile: mobileNumber,
      event_name: "login",
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content
    };

    setLoading(true);
    sendotpForLogin(param).then(resp => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setStorage("mobile", mobileNumber);
        setStorage("cust_profile_id", resp?.data?.Data?.cust_profile_id);
        setScreen("otpScreen");
        setSeconds(30);
        setMessage({ type: 'success', msg: resp?.data?.Message, place: "globle" });
      } else {
        setMobile(["", "", "", "", "", "", "", "", "", ""]);
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        let msg = resp?.data?.Message || resp?.data?.error || "An error occurred";
        setMessage({ type: 'error', msg: msg });
      }
    });
  };

  const resendOtp = () => {
    const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } = getUtmParams();

    const param = {
      profile_id: getStorage("cust_profile_id"),
      event_name: "resend_otp",
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content
    };

    setLoading(true);
    sendotpForLogin(param).then(resp => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setScreen("otpScreen");
        setSeconds(30);
        setMessage({ type: 'success', msg: resp?.data?.Message, place: "globle" });
      } else {
        setMobile(["", "", "", "", "", "", "", "", "", ""]);
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        let msg = resp?.data?.Message || resp?.data?.error || "An error occurred";
        setMessage({ type: 'error', msg: msg });
      }
    });
  };

  const verifyOTP = async () => {
    let otpNumber = otp.join("");

    if (otpNumber.length !== 4) {
      setMessage({ type: 'error', msg: "Please enter 4-digit OTP" });
      return;
    }

    const param = {
      event_name: "otp_verify",
      profile_id: getStorage("cust_profile_id"),
      otp: otpNumber,
    };

    setLoading(true);
    try {
      const resp = await verifyotpForLogin(param);

      setLoading(false);

      if (resp?.data?.Status === 1) {
        setResponce(resp?.data);
        setStorage("next_step", resp?.data?.Data?.next_step);
        setStorage("token", resp?.data?.Data?.app_login_token);
        setMessage({ type: 'success', msg: resp?.data?.Message, place: "globle" });

        if (resp?.data?.Data?.eligibility_status === 1) {
          setStorage("eligibility", 1); // Store eligibility as 1 if eligible
        } else {
          setStorage("eligibility", 0); // Store eligibility as 0 if not eligible
        }

        // Navigate based on eligibility
        if (getStorage('eligibility') === 1) {
          console.log("Navigating to /my-dashboard/eligibility");
          navigate('/my-dashboard/eligibility');
        } else {
          console.log("Navigating to /my-dashboard");
          navigate('/my-dashboard');
        }
      } else {
        setOtp(["", "", "", ""]);
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        let msg = resp?.data?.Message || resp?.data?.error || "An error occurred";
        setMessage({ type: 'error', msg: msg });
      }
    } catch (err) {
      setLoading(false);
      setMessage({ type: 'error', msg: "Error verifying OTP" });
      console.error("OTP Verification Error:", err);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      verifyOTP();
    }
  };

  const handleKeyDown1 = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      sendOtp();
    }
  };

  useEffect(() => {
    if (isEmpty(message)) return;
    const timer = setTimeout(() => {
      setMessage({});
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [message]);


  const features = [
    "Get pre-approved instant loan",
    "Loan up to ₹1,00,000",
    "No collateral required",
    "Flexible repayment options",
    "Secure & paperless process",


  ];

  return (
    <>
      <Helmet>
        <style>
          {`
          .table-wrapper {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            margin: 20px 0;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th, td {
            padding: 10px;
            text-align: left;
            border: 1px solid #ddd;
          }

          th {
            background-color: #f4f4f4;
          }

          @media (max-width: 768px) {
            table {
              width: 100%;
            }
            th, td {
              font-size: 12px;
              padding: 8px;
            }
            th {
              font-size: 14px;
            }
          }

          @media (max-width: 480px) {
            th, td {
              font-size: 10px;
              padding: 6px;
            }
          }
        `}
        </style>
      </Helmet>


      <Loginwrapper className="flex1 justify-center1">

        <div className="container w-90 m-auto rounded-lg">
          <div className="row">
            <div className="col-lg-6 bg-white" style={{ borderRadius: '10px 0 0 10px' }}>
              <div className="row py-5 px-5">


                <div className="feature-card ">

                  {/* Logo */}
                  <div className="mb-4 text-center">
                    <img
                      src={logo}
                      alt="Credu Money"
                      className="img-fluid feature-logo" style={{width:'50%'}}
                    />
                  </div>

                  {/* Heading */}
                  {/* <h2 className="fw-bold text-dark mb-4 text-uppercase pt-5 pb-3">
                    Key Features
                  </h2> */}

                  <p style={{ lineHeight: '26px', fontSize: '18px' }}>Manage temporary cash flow gaps and important financial commitments through a secure and structured digital process. </p>

                  {/* Features */}
                  <div className="text-start ">
                    <ul className="list-unstyled feature-list align-items-center pt-5">
                      {features.map((feature, index) => (
                        <li key={index} className="pb-2" style={{ fontSize: '16px', color: '#000' }}>
                          <span className="check-icon border" style={{ width: '30px', height: '30px', display: 'inline-table', borderRadius: '3px', textAlign: 'center' }} >✓</span> &nbsp;
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>


                </div>
              </div>

            </div>
            <div className="col-lg-6 bg-primary text-white flex align-items-center p-5 " style={{ borderRadius: '0px 10px 10px 0px' }}>
              <div className="login-inner-rihgt">
                <h2 className="fw-bold mb-2 text-uppercase pb-5 ">
                  Apply for Loan
                </h2>
                <Alert setMessage={setMessage} message={message} />
                {screen === "getOtp" ? (
                  <>
                    <p style={{ fontSize: "15px" }}>Enter your 10 digit mobile number to get started</p>
                    <div className="otpBox">
                      <MobileInput
                        name="mobile"
                        setOtp={setMobile}
                        otp={mobile}
                        isDisable={false}
                        error={mobileError}
                        onChange={(e) => onChanges(e, "sendOtp")}
                        placeholder="*"
                        onKeyDown={handleKeyDown1}
                        inputRefs={inputRefs}
                      />

                    </div>
                    <div className="flex confirm pt-3" >
                      <input
                        style={{ height: "15px", width: "35px", marginRight: "10px" }}
                        name="radio"
                        type="radio"
                        checked={accept}
                        onChange={() => {
                          setAccept(!accept);
                          setAcceptError("");
                        }}
                      />
                      <p style={{ fontSize: "14px", lineHeight: "20px" }}>
                        By selecting this checkbox, I authorize the receipt of digital communications
                        {showMore ? (
                          <span>
                            , such as phone calls, SMS, emails, and WhatsApp messages, at the phone number, email address, and app I have provided from CreduMoney. Furthermore, I acknowledge that I have reviewed and accept the , <Link
                              to="/termsandconditions"
                              style={{color:'red'}}
                              onClick={(e) => {
                                e.preventDefault();
                                window.open("/termsandconditions", "_blank", "noopener,noreferrer");
                              }}
                            >
                             Terms and Conditions 
                            </Link>
                             &nbsp; and <Link to="/privacypolicy" style={{color:'red'}} onClick={(e) => {
                              e.preventDefault();
                            }}> Privacy Policy</Link>.
                          </span>
                        ) : (
                          <span>
                            <button onClick={() => setShowMore(true)} style={{ cursor: 'pointer', border: 'none', background: 'none', color: '#26b9db', textDecoration: 'none' }}>read more</button>
                          </span>
                        )}
                      </p>
                    </div>
                    {acceptError && <p style={{ color: 'red', fontSize: '12px' }}>{acceptError}</p>}
                    <div className="button">
                      <Button title="GET OTP" onClick={sendOtp} loading={loading} />
                    </div>
                  </>
                ) :
                  (
                    <>
                      <p style={{ fontSize: "20px", fontWeight:600 }}>
                        Mobile number : ******{(getStorage("mobile") && getStorage("mobile").length >= 10) ? getStorage("mobile").slice(-4) : 'N/A'} <CiEdit />
                      </p>
                      <p className="pt-2">Please enter the OTP to unlock your next step.</p>
                      <div className="otpBox">
                        <OtpInput
                          type="text"
                          setOtp={setOtp}
                          otp={otp}
                          isDisable={false}
                          placeholder="*"
                          onKeyDown={handleKeyDown}
                          inputRefs={inputRefs}
                        />
                      </div>
                      <div className="button mt-5">
                        <Button title="Verify OTP" onClick={verifyOTP} loading={loading} />
                      </div>
                      <div className="resend mt-5">
                        {seconds > 0 ? (
                          <p className="none">
                            Didn't receive the OTP? <FontAwesomeIcon icon={faClock} style={{ marginRight: '5px', marginLeft: '5px', color: '#fff' }} /> <span style={{ color: "#fff", fontWeight: 600 }}>00:{seconds}s</span>
                          </p>
                        ) : (
                          <button
                            onClick={!loading ? resendOtp : () => { }}
                            style={{
                              backgroundColor: 'transparent',
                              border: '1px solid #fff',
                              color: '#fff',
                              padding: '10px 9px',
                              borderRadius: '5px',
                              cursor: 'pointer',
                              fontSize: '13px',                           
                              transition: 'background-color 0.3s, color 0.3s',
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = '#26b9db';
                              e.target.style.color = '#fff';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = 'transparent';
                              e.target.style.color = '#26b9db';
                            }}
                          >
                            Resend OTP
                          </button>
                        )}
                      </div>
                    </>
                  )
                }
              </div>








            </div>
          </div>
        </div>



      </Loginwrapper>


    </>
  );
}

export default Login;
